
import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../../redux/library/selector';
import { useSelector } from 'react-redux';
import MediaInfoComponent from '../../../../../../common/components/common/media-info.component';


export default function NewsLetterBasicInfoComponent ({mediaFiles,handleFormItemChange,changeImage,handleInnerFormChange, selectedNewsLetter}: any) {
  const libraryData = useSelector(selectListItems)
   return (
    <>
     <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
            label="Title"
            labelField="Title"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'Title'
              );
            }}
            type="text"
            value={selectedNewsLetter?.Title}
        />
              <InputContainer
            label="Short Description"
            labelField="Short"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'Short'
              );
            }}
           
            type="text"
            value={selectedNewsLetter?.Short}
        />
           <InputContainer
            label="MetaKeywords"
            labelField="MetaKeywords"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'MetaKeywords'
              );
            }}
           
            type="text"
            value={selectedNewsLetter?.MetaKeywords}
        />
          <InputContainer
            label="MetaDescription"
            labelField="MetaDescription"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'MetaDescription'
              );
            }}
           
            type="text"
            value={selectedNewsLetter?.MetaDescription}
        />
          <InputContainer
            label="MetaTitle"
            labelField="MetaTitle"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'MetaTitle'
              );
            }}
           
            type="text"
            value={selectedNewsLetter?.MetaTitle}
        />
          <InputContainer
            label="NewsLetterShow Start Date"
            labelField="NewsItemShowStartDateUtc"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'NewsItemShowStartDateUtc'
              );
            }}
            type="date"
            value={selectedNewsLetter?.NewsItemShowStartDateUtc}
        />
          <InputContainer
            label="NewsLetterShow End Date"
            labelField="NewsItemShowEndDateUtc"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'NewsItemShowEndDateUtc'
              );
            }}
            type="date"
            value={selectedNewsLetter?.NewsItemShowEndDateUtc}
        />
          <InputContainer
            label="Comments Allowed"
            labelField="IsCommentsAllowed"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event,
                'IsCommentsAllowed'
              );
            }}
            type="checkbox"
            value={selectedNewsLetter?.IsCommentsAllowed}
        />
          <InputContainer
            label="Published"
            labelField="Published"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event,
                'Published'
              );
            }}
            type="checkbox"
            value={selectedNewsLetter?.Published}
        />
        <div className='col-span-full'>
        <InputContainer 
          label="Full Description"
          name="Full"
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event.target.value,
              'Full'
            )
          }}
          type="text"
          value={selectedNewsLetter?.Full}
      /></div>
     </div>
  }
    expandedPanel="BasicInfo"
    headerTitle="Basic Info"
/>
<AccordionContainer
    child={
          <div>
   <MediaInfoComponent
      changeImage={changeImage}
      fileTypes={libraryData?.result?.FileType}
      onFormItemChange={handleFormItemChange}
      mediaFiles={mediaFiles}
      />
</div>
  }
    expandedPanel="NewsLetter Media"
    headerTitle="NewsLetter Media Info"
/>
</>
  )
}